import { useSearchParams } from "react-router-dom";

export function useSearchParamsPassphrase(): string {
  const [searchParams] = useSearchParams();
  return searchParams.get("passphrase") || "";
}
